import constant from '../../../utils/constant';
export default constant({
    TOP_LEFT: 'TopLeft',
    TOP_RIGHT: 'TopRight',
    TOP_CENTER: 'TopCenter',
    BOTTOM_LEFT: 'BottomLeft',
    BOTTOM_RIGHT: 'BottomRight',
    BOTTOM_CENTER: 'BottomCenter'
});
